/**
 * @namespace Newsletter
 * @aka SWRNEU.Newsletter
 */
SWRNEU.Newsletter = (function ($) {
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'newsletter';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var SERVLET_PATH = window.location.port === '8080' ? `/cms/system/servlet/newsletter.servlet?target=js` : `/system/servlet/newsletter.servlet?target=js`;
  var API_URL = window.isFractal ? `https://www.swr.de${SERVLET_PATH}` : `${window.location.protocol}//${window.location.host}${SERVLET_PATH}`;
  var OVERLAY_HTML = '' +
    '<h3>{headline}</h3>' +
    '<p>{text}</p>' +
    '<form class="form form-modal" id="form-newsletter" data-spy="validate" data-send-via-js="true" action="#" method="post" data-pjax="false">' +
    '<div class="form-group empty-input" data-required="true">' +
    '<label for="newsletter-email">' +
    'E-Mail:<span class="required"> *</span>' +
    '</label>' +
    '<input class="form-control" id="newsletter-email" type="email" name="emailAddress" aria-invalid="false" placeholder="E-Mail" required>' +
    '</div>' +

    '{extraHtml}' +

    '<input type="hidden" name="restAddressInterfaceId" value="{restAddressInterfaceId}"/>' +
    '<button type="submit" class="btn btn-primary" data-loading-text="Daten werden übermitteln …">Abonnieren</button>' +
    '</form>';
  var OVERLAY_HTML_SR = '' +
    '<h3>{headline}</h3>' +
    '<p>{text}</p>' +
    '<form class="form form-modal" id="form-newsletter" data-spy="validate" data-send-via-js="true" action="#" method="post" data-pjax="false">' +
    '  <div class="form-group empty-input" data-required="false">' +
    '    <label for="newsletter-name">' +
    '      Name:' +
    '    </label>' +
    '    <input class="form-control" id="newsletter-name" type="text" name="name" aria-invalid="false" placeholder="Name">' +
    '  </div>' +
    '  <div class="form-group empty-input" data-required="true">' +
    '    <label for="newsletter-email">' +
    '      E-Mail:<span class="required"> *</span>' +
    '    </label>' +
    '    <input class="form-control" id="newsletter-email" type="email" name="emailAddress" aria-invalid="false" placeholder="E-Mail" required>' +
    '  </div>' +

    '{extraHtml}' +

    '  <div class="form-group contains-checkbox" data-required="true">' +
    '    <div class="checkbox">' +
    '      <label for="newsletter-privacyPolice">' +
    '        <input type="checkbox" id="privacyPolice" name="privacyPolice" aria-invalid="false" required="">' +
    '        <span class="form-control-indicator"></span>' +
    '        <span class="label-text">Ich habe die <a href="https://www.swr.de/datenschutz/datenschutz-118.html" class="link">Datenschutzerklärung</a> gelesen, verstanden und akzeptiere sie.</span>' +
    '        <span class="required"> *</span>' +
    '      </label>' +
    '  </div>' +
    '  <input type="hidden" name="newsletterId" value="{newsletterId}"/>' +
    '  <button type="submit" class="btn btn-primary" data-loading-text="Daten werden übermitteln …">Abonnieren</button>' +
    '</form>';

  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };

  var Selector = {
    DATA_SPY: '[data-spy="newsletter"]'
  };

  var type = null, days = 90;

  /******
   * In diesem Array, werden die einzelnen Popups definiert.
   * Jedes Popup kann folgende Felder haben und damit bestimmte Funktionen auslösen:
   *
   * Allgemeine Pflichtfelder:
   * - name
   *     Wird ins Cookie geschrieben, das beim Schließen des Popups gesetzt wird.
   * - newsletterId
   *     ID, die dafür sorgt, dass das Newsletter-Servlet die Anmeldung weitergibt.
   * - headerCaption
   *     Die allgemeine Überschrift des Popup (bspw. "Newsletter abonnieren")
   * - headline
   *     Überschrift im Content-Bereich des Popup
   * - text
   *     Beschreibungstext für den Newsletter
   * - paths
   *     exakte Paths, unter denen das Popup auftauchen soll. (bspw. "/swraktuell/swraktuell-rp-100.html")
   *
   * Optionale Felder:
   * startDates und endDates müssen entweder gleich viele Werte enthalten oder
   * endDates keine.
   *
   * - startDates
   *     Wurde für SWR Aktuell eingebaut und kann maximal 2 Startzeiten enthalten.
   *     Kann auch alleine vorhanden sein, darf dann aber nur einen Wert enthalten.
   * - endDates
   *     Wurde für SWR Aktuell eingebaut und kann maximal 2 Endzeiten enthalten.
   * - timespan
   *     Wenn das Popup erst ab einem bestimmten Zeitpunkt sichtbar sein, muss dieser Parameter
   *     gesetzt sein und den Wert true haben
   * - structureNode
   *     Ein Strukturknoten, unter dem das Overlay angezeigt werden soll, wirkt nur in
   *     Kombination mit dem nachfolgenden Feld
   * - triggerByElement
   *     Element auf der Seite, das dafür sorgt, dass das Overlay
   *     angezeigt wird.
   * - extraHtml
   *     HTML, das nach dem E-Mail-Feld eingefügt werden soll
   */
  var overlays = [
    {
      name: 'rp',
      newsletterId: '503',
      headerCaption: 'Newsletter abonnieren',
      headline: 'SWR Aktuell Newsletter - jetzt abonnieren',
      text: 'Morgens direkt auf dem neuesten Stand sein? Mit dem Newsletter "SWR Aktuell - der Morgen in Rheinland-Pfalz" landen die Nachrichten montags bis freitags direkt im Mailpostfach.',
      paths: ['/swraktuell/swraktuell-rp-100.html', '/swraktuell/rheinland-pfalz/index.html'],
      startDates: [
        new Date('Oct 16, 2023 00:00:00').getTime(), //Beginn Woche 1
        new Date('Oct 30, 2023 00:00:00').getTime(), //Beginn Woche 3
      ],
      endDates: [
        new Date('Oct 23, 2023 00:00:00').getTime(), //Beginn Woche 2
        new Date('Nov 11, 2023 00:00:00').getTime(), //Beginn Woche 4 ff
      ],
      timespan: true
    },
    {
      name: 'bw',
      newsletterId: '502',
      headerCaption: 'Newsletter abonnieren',
      headline: 'SWR Aktuell Newsletter - jetzt abonnieren',
      text: 'Morgens direkt auf dem neuesten Stand sein? Mit dem Newsletter "SWR Aktuell - der Morgen in Baden-Württemberg" landen die Nachrichten montags bis freitags direkt im Mailpostfach.',
      paths: ['/swraktuell/swraktuell-bw-100.html', '/swraktuell/baden-wuerttemberg/index.html'],
      startDates: [
        new Date('Oct 16, 2023 00:00:00').getTime(), //Beginn Woche 1
        new Date('Oct 30, 2023 00:00:00').getTime(), //Beginn Woche 3
      ],
      endDates: [
        new Date('Oct 23, 2023 00:00:00').getTime(), //Beginn Woche 2
        new Date('Nov 11, 2023 00:00:00').getTime(), //Beginn Woche 4 ff
      ],
      timespan: true
    },
    {
      name: 'aktuell',
      newsletterId: '501',
      headerCaption: 'Newsletter abonnieren',
      headline: 'SWR Aktuell Newsletter - Der Tag im Südwesten - jetzt abonnieren',
      text: 'Sie möchten auf dem Laufenden bleiben, was im Südwesten passiert? Dann abonnieren Sie den SWR Aktuell Newsletter - Der Tag im Südwesten. Montag bis Freitag kommt der Newsletter nachmittags zu Ihnen.',
      paths: ['/swraktuell/swraktuell-100.html', '/swraktuell/index.html'],
      structureNode: '/swraktuell/',
      triggerByElement: 'aside a[href="/swraktuell/newsletter-anmeldung-100.html"]',
      extraHtml: '<fieldset class="form-fieldset form-fieldset-radio">' +
        '<legend class="form-fieldset-legend">Welches Bundesland interessiert Sie besonders?</legend>' +
        '<div class="radio" data-required="false">' +
        '<label for="badenwuerttemberg">' +
        '<input type="radio" id="badenwuerttemberg" name="regionale_praeferenz" aria-invalid="false" value="Baden-Württemberg" required>' +
        '<span class="form-control-indicator"></span>' +
        'Baden-Württemberg' +
        '</label>' +
        '</div>' +
        '<div class="radio" data-required="false">' +
        '<label for="rheinlandpfalz">' +
        '<input type="radio" id="rheinlandpfalz" name="regionale_praeferenz" aria-invalid="false" value="Rheinland-Pfalz" required>' +
        '<span class="form-control-indicator"></span>' +
        'Rheinland-Pfalz' +
        '</label>' +
        '</div>' +
        '<div class="radio" data-required="false">' +
        '<label for="beide">' +
        '<input type="radio" id="beide" name="regionale_praeferenz" aria-invalid="false" checked value="Beide Bundesländer" required>' +
        '<span class="form-control-indicator"></span>' +
        'Beide Bundesländer' +
        '</label>' +
        '</div>' +
        '</fieldset>' +
        '<input type="hidden" name="userDetails" value="regionale_praeferenz">'
    }
  ];

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Newsletter = function () {

    function Newsletter (element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.overlayData = {};

      if (COMMON.Browser.isBot) {
        console.log('Newsletter-Modal should not be displayed');
        return;
      }

      self._checkType();
    }

    /******
     * Wenn der Typ "overlay" ist, dann soll ein Overlay angezeigt werden.
     * Andernfalls soll nur das Submit-Handling erfolgen.
     * @private
     */
    Newsletter.prototype._checkType = function _checkType () {
      var self = this;

      switch (type) {
        case 'inline':
          console.log('Newsletter auf der Seite - kein Overlay');
          self._cleanUp();
          break;
        case 'overlay':
          console.log('Kein Newsletter auf der Seite - Overlay anzeigen');
          self._createOverlay();
          break;
      }
    };

    Newsletter.prototype._cleanUp = function _cleanUp () {
      var self = this;
      var $form = self.$element.find('.form');
      var $checkbox = $form.find('.form-group:has(.checkbox)');
      var headline = self.$element.find('.headline').text();
      var $noscript = self.$element.find('.lead > p').find('noscript');

      self.$element.removeClass().addClass("frontmod-schnellanmeldebox");
      self.$element.find('header, footer').remove();
      var text = self.$element.find('.lead > p').html();
      self.$element.empty();

      var $content = $('<div class="content-wrapper"></div>');
      $content.append('<h2>' + headline + '</h2>');
      $content.append('<p>' + text + '</p>');
      $content.append($noscript);

      $form.attr('data-spy', 'validate');
      $form.attr('data-send-via-js', true);
      $form.addClass('variant-dark');
      $form.find('.btn').addClass('btn-primary-invert-constant');

      if ($checkbox.length !== 0) {
        var $input = $checkbox.find('input');
        var $formControlIndicator = $checkbox.find('.form-control-indicator');
        var $required = $checkbox.find('.required');
        var $label = $checkbox.find('label');
        var checkboxLabelHTML = $checkbox.find('label').html();

        checkboxLabelHTML = checkboxLabelHTML.substring(checkboxLabelHTML.indexOf('Ich'), checkboxLabelHTML.indexOf('sie.') + 4);
        checkboxLabelHTML = '<span class="label-text">' + checkboxLabelHTML + '</span>';

        $label.empty();
        $label.append($input);
        $label.append($formControlIndicator);
        $label.append($(checkboxLabelHTML));
        $label.append($required);
      }

      $content.append($form);

      self.$element.append($content);

      self.$dialog = self.$element;
      self._bindEvents();
    };

    /*******
     * In dieser Funktion wird das Newsletter-Overlay zusammengebaut.
     * Dafür gibt es ein paar Bedingungen: beispielsweise ob wir uns
     * im richtigen Strukturknoten oder unter dem richtigen Pfad befinden
     * und ob der Start-/End-Zeitpunkt des jeweiligen Overlays erreicht wurde.
     *
     * Zu Testzwecken kann man so vorgehen:
     * Wenn man sich auf einer Seite einen Newsletter-Overlay anzeigen lassen möchte,
     * kann man das über den URL-Parameter showNewsletter=true steuern.
     * Zusätzlich kann man noch angeben welches Overlay angezeigt werden soll:
     * overlayIndex=0 -> SWR Aktuell RP
     * overlayIndex=1 -> SWR Aktuell BW
     * overlayIndex=2 -> SWR Aktuell beide Bundesländer
     *
     * @private
     */
    Newsletter.prototype._createOverlay = function _createOverlay () {
      var self = this;
      var now = SWRNEU.Util.getNow();
      var searchParameter = window.location.search;
      var customRequest = (searchParameter.indexOf('showNewsletter=true') !== -1);
      var hasOverlayIndex = (searchParameter.indexOf('overlayIndex') !== -1);
      var overlayIndex = 2;

      if (hasOverlayIndex) {
        var start = searchParameter.indexOf('overlayIndex') + 13;
        overlayIndex = searchParameter.substring(start, start + 1);
      }

      if (customRequest) {
        self.overlayData = overlays[overlayIndex];
      }

      if (!customRequest) {
        for (var overlay of overlays) {
          console.log(overlay);
          if (overlay.hasOwnProperty('triggerByElement') && overlay.hasOwnProperty('structureNode')) {
            //Wenn das Overlay nur unter bestimmten Strukturknoten angeziegt werden soll,
            //und nur, wenn ein bestimmtes Element auf der Seite ist,
            //muss zunächst die URL auf das Vorkommen des Strukturknotens
            //untersucht werden:
            if (window.location.pathname.indexOf(overlay.structureNode) !== -1) {
              //Wir befinden uns im gewünschten Strukturknoten
              var $triggerByElement = $(overlay.triggerByElement);
              if ($triggerByElement.length !== 0) {
                //Das gewünschte Element zum Auslösen des Overlays ist vorhanden
                self.overlayData = overlay;
                break;
              }
            }
          } else if (overlay.hasOwnProperty('paths')) {
            if (overlay.paths.includes(window.location.pathname)) {
              self.overlayData = overlay;
              break;
            }
          }
        }

        if (!window.isFractal) {
          //Wenn der Nutzer abonniert hat, dann nicht anzeigen:
          var abonniert = COMMON.Storage.local.getItem('newsletter.' + self.overlayData.name + '.overlay.abonniert');
          if (abonniert) {
            return;
          }
          //Wenn der Nutzer das Overlay bereits geschlossen hatte, dann nicht anzeigen:
          var result = COMMON.Storage.local.getItem('newsletter.' + self.overlayData.name + '.overlay');
          if (result) {
            return;
          }

          //Sollte es sich nicht um einen Test handeln und die Overlay-Daten haben Start-/End-Daten, dann
          //muss geprüft werden, ob wir uns in diesen Zeiträumen befinden.
          if (self.overlayData.timespan && self.overlayData.hasOwnProperty('startDates') && self.overlayData.hasOwnProperty('endDates')) {
            if (now < self.overlayData.startDates[0]) {
              //Vor Woche 1
              console.log(`Startdatum (${new Date(self.overlayData.startDates[0]).toDateString()}) noch nicht erreicht.`);
              return;
            } else if (now < self.overlayData.startDates[1] && now < self.overlayData.endDates[0]) {
              //Woche 1
              //Overlay darf sichtbar sein
              console.log(`Woche 1: Overlay sichtbar. Von ${new Date(self.overlayData.startDates[0]).toDateString()} bis ${new Date(self.overlayData.endDates[0]).toDateString()}`);
            } else if (now < self.overlayData.startDates[1] && now > self.overlayData.endDates[0]) {
              //Woche 2
              //Overlay darf nicht sichtbar sein
              console.log(`Woche 2: Overlay nicht sichtbar. Von ${new Date(self.overlayData.endDates[0]).toDateString()} bis ${new Date(self.overlayData.startDates[1]).toDateString()}`);
              return;
            } else if (now > self.overlayData.startDates[1] && now > self.overlayData.endDates[0] && now < self.overlayData.endDates[1]) {
              //Woche 3
              //Overlay darf sichtbar sein
              console.log(`Woche 3: Overlay sichtbar. Von ${new Date(self.overlayData.startDates[1]).toDateString()} bis ${new Date(self.overlayData.endDates[1]).toDateString()}`);
            } else if (now > self.overlayData.startDates[1] && now > self.overlayData.endDates[1]) {
              //Woche 4 ff
              //Overlay darf nicht sichtbar sein
              console.log(`Woche 4 ff: Overlay nicht sichtbar. Ab ${new Date(self.overlayData.endDates[1]).toDateString()}`);
              return;
            }
          }
        }
      }

      console.log(self.overlayData);

      if (Object.keys(self.overlayData).length === 0) {
        console.log('Newsletter-Modal wird nicht angezeigt, da es keine Daten für das gewünschte Overlay gibt.');
        return;
      }

      //Wenn alles korrekt ist, wird das Overlay angezeigt:
      self._showOverlay();
    };

    /******
     * Das Dialog-Fenster mit Newsletter-Abo-Formular wird mit Inhalt gefüllt
     * und angezeigt. Die Event-Handler werden gebunden.
     * @private
     */
    Newsletter.prototype._showOverlay = function _showOverlay () {
      var self = this;
      var id = COMMON.Utils.uuid();
      var header = self.overlayData.headerCaption;
      var body = COMMON.Utils.template(OVERLAY_HTML, {
        headline: self.overlayData.headline,
        extraHtml: self.overlayData.extraHtml ?? '',
        restAddressInterfaceId: self.overlayData.newsletterId,
        text: self.overlayData.text,
      });
      //Für die neuen SR-Newsletter:
      /*var body = COMMON.Utils.template(OVERLAY_HTML_SR, {
        headline: self.overlayData.headline,
        extraHtml: self.overlayData.extraHtml ?? "",
        newsletterId: self.overlayData.newsletterId,
        text: self.overlayData.text,
      });*/

      self.$dialog = $(SWRNEU.Dialog.createDialog(id, header, body));
      self.$element.append(self.$dialog);
      console.log(self.$dialog);
      SWRNEU.Dialog.addEventHandler(self.$dialog);
      self.$dialog.trigger('swr:dialog:open');

      self._bindEvents();
    };

    /*******
     * Das Absenden des Formulars geschieht per JS.
     * Es werden Daten an das Newsletter-Servelet gesendet.
     * @private
     */
    Newsletter.prototype._bindEvents = function _bindEvents () {
      var self = this;
      var $submitButton = self.$dialog.find('button[type=submit], input[type=submit]');
      var val = $submitButton.is('input') ? 'val' : 'html';

      self.$form = self.$dialog.find('.form');

      self.$form.on('common:validate:submit:validationPassed',
        function (event, submitEvent, $form) {
          _handleFormSubmit(submitEvent);
        }
      );
      self.$form.on('swr:newsletter:sendsuccess', _handleFormSuccess);
      self.$form.on('swr:newsletter:senderror', _handleFormError);

      //Dialogfenster wird geschlossen
      self.$dialog.on('swr:dialog:close', function () {
        //Es soll gespeichert werden, wenn der Nutzer das Overlay geschlossen hat.
        var expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

        if (window.isFractal) {
          expires.setTime(expires.getTime() + 60);
        }
        COMMON.Storage.local.setItem('newsletter.' + self.overlayData.name + '.overlay', true, expires);

        self.$dialog.remove();
      });

      function _handleFormSubmit (event) {
        console.log('SUBMIT');
        event.preventDefault();

        //Der Close-Button des Dialogfensters wird disabled
        self.$dialog.find('[data-dialog-close]').prop('disabled', true);

        //Der Text des Sendebuttons bekommt einen anderen Text
        $submitButton.addClass('disabled').attr('disabled', 'disabled').prop('disabled', true);
        $submitButton.data('resetText', $submitButton[val]());
        $submitButton[val]($submitButton.data('loadingText'));

        //Fehlermeldungen werden zurückgesetzt
        self.$form.find('.alert.alert-danger').remove();

        //Die Validierung wird zurückgesetzt
        self.$form.find('.has-error,.form-group-error').removeClass('has-error form-group-error');
        self.$form.find('.form-error').remove();

        //Die Daten des Formulars werden zusammengebaut
        var formData = self.$form.serializeArray();

        //Um einen Fehler zu simulieren:
        //self.$dialog.trigger('swr:newsletter:senderror', {jqXHR: {jqXHR: {status: 500}}, textStatus: ""});
        //return;

        // submit form data
        $.ajax({
          url: API_URL,
          data: formData,
          method: 'post',
          crossDomain: true
        }).done(function (data, textStatus, jqXHR) {
          self.$form.trigger('swr:newsletter:sendsuccess', { data: data, textStatus: textStatus, jqXHR: jqXHR });
        }).fail(function (jqXHR, textStatus, errorThrown) {
          self.$form.trigger('swr:newsletter:senderror', { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
        }).always(function () {
          //Close-Button wieder enablen
          self.$dialog.find('[data-dialog-close]').prop('disabled', false);
        });
      }

      function _handleFormSuccess (event, options) {
        $(document).trigger('loader.hide');
        // show response
        _renderSuccessAlert('Erfolgreich versendet', '<p>Vielen Dank für Ihr Interesse an unserem Newsletter-Angebot. Sie erhalten in Kürze eine E-Mail zur Bestätigung Ihrer Anmeldung, bitte klicken Sie dort auf den Bestätigungslink.</p>' +
          '<p>Falls Sie die Bestätigungsmail nicht in Ihrem Posteingang vorfinden, überprüfen Sie bitte Ihren Spam-Ordner.</p>');
      }

      function _handleFormError (event, options) {
        $(document).trigger('loader.hide');
        //Im Fehlerfall muss jede Fehlermeldung durchgegangen werden und an
        //das entsprechende Feld geschrieben werden
        switch (options.jqXHR.status) {
          case 400:
            $.each(options.jqXHR.responseJSON.errorMessages, function (name, message) {
              var $formGroup = self.$form.find('[name="' + name + '"]').closest('.form-group');
              $formGroup.addClass('has-error form-group-error');
              if (message === 'Fehler bei der Verarbeitung') {
                message = 'Bitte wählen Sie ein Bundesland.';
              }
              $formGroup.append(COMMON.Utils.template('<p class="form-error">{text}</p>', {
                text: message
              }));
            });
            $submitButton.removeClass('disabled').prop('disabled', false);
            $submitButton[val]('Abonnieren');
            break;
          case 409:
            //Bei diesem Fehler wird das Formular durch eine Erfolgsmeldung ersetzt:
            _renderSuccessAlert('Bereits angemeldet', '<p>Vielen Dank für Ihr Interesse an unserem Newsletter-Angebot. Sie haben sich bereits für diesen Newsletter angemeldet.</p>');
            break;
          default:
            //Bei sonstigen Fehlern wird das Formular durch eine
            //allgemeine Fehlermeldung ersetzt:
            _renderErrorAlert('Fehler beim Versenden', '<p>Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.</p>');
            break;
        }
      }

      function _renderSuccessAlert (title, text) {
        var $successContainer = self.$element;

        if (type === 'overlay') {
          $successContainer = self.$dialog.find('.dialog-body');
        }

        $successContainer.empty().append('<div class="alert alert-success">' +
          '<p class="title">' + title + '</p>' +
          text +
          '</div>');

        //Es wird gespeichert, dass der Nutzer den Newsletter abonniert hat:
        var expires = new Date();
        expires.setFullYear(expires.getFullYear() + 10);
        COMMON.Storage.local.setItem('newsletter.' + self.overlayData.name + '.overlay.abonniert', true, expires);
      }

      function _renderErrorAlert (title, text) {
        var $errorContainer = self.$element;

        if (type === 'overlay') {
          $errorContainer = self.$dialog.find('.dialog-body');
        }

        $errorContainer.empty().append('' +
          '<div class="alert alert-danger">' +
          '  <p class="title">' + title + '</p>' +
          text +
          '  <button id="close-feedback" type="button" class="btn btn-primary btn-primary-invert-constant btn-medium" data-pjax-reload="" data-target="body" data-scrollto="true">' +
          '' + SWRNEU.Util.svgIcon('reload') + ' Seite neu laden' +
          '  </button>' +
          '</div>');
      }
    };

    // public
    Newsletter.prototype.dispose = function dispose () {
      this.$element.off(EVENT_KEY);

      this.$element.find('.hgroup').remove();

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Newsletter._jQueryInterface = function _jQueryInterface () {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Newsletter(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Newsletter;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  if ($(Selector.DATA_SPY).length === 0) {
    //Wenn kein Element auf der Seite gefunden wird,
    //ist der Body das Element und das Newsletter-
    //Handling ist vom Typ "overlay"
    var $element = $('body');
    type = 'overlay';
    Newsletter._jQueryInterface.call($element, $element.data());
  } else {
    //Wird ein Element auf der Seite gefunden,
    //ist das Newsletter-Handling vom Typ "inline"
    $(Selector.DATA_SPY).each(function () {
      var $element = $(this).closest('.frontmod-schnellanmeldebox');
      type = 'inline';
      Newsletter._jQueryInterface.call($element, $element.data());
    });
  }

  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    if ($(options.container).find(Selector.DATA_SPY).length === 0) {
      //Wenn kein Element auf der Seite gefunden wird,
      //ist der Body das Element und das Newsletter-
      //Handling ist vom Typ "overlay"
      var $element = $('body');
      type = 'overlay';
      Newsletter._jQueryInterface.call($element, $element.data());
    } else {
      //Wird ein Element auf der Seite gefunden,
      //ist das Newsletter-Handling vom Typ "inline"
      $(options.container).find(Selector.DATA_SPY).each(function () {
        var $element = $(this).closest('.frontmod-schnellanmeldebox');
        type = 'inline';
        Newsletter._jQueryInterface.call($element, $element.data());
      });
    }
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Newsletter._jQueryInterface;
  $.fn[NAME].Constructor = Newsletter;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Newsletter._jQueryInterface;
  };

  return Newsletter;

})(window.jQuery);
